import { Container, Stack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import Footer from '~/components/footer/Footer';
import Header from '~/components/header/Header';
import PlaylistContentContainer from '~/components/playlists/PlaylistContentContainer';
import PlaylistsResult from '~/components/playlists/PlaylistsResult';
import SearchInput from '~/components/searchInput/SearchInput';
import SearchResult from '~/components/searchResult/SearchResult';
import { useGetPlaylistsQuery } from '~/services/api/playlist.service';
import { useSelectedPlaylistIdSelector } from '~/store/slices/playlist-hook';
import { useSearchSelector } from '~/store/slices/search-hook';
import { BRAND_SAND_COLOR } from '~/themes/theme';

function CataloguePage() {
  const { i18n } = useTranslation();
  useGetPlaylistsQuery({
    language: i18n.language.toLocaleUpperCase(),
  });
  const searchValue = useSearchSelector();
  const selectedPlaylistId = useSelectedPlaylistIdSelector();

  return (
    <Stack pt={6}>
      <Header />

      <SearchInput />

      <Container
        minW='100%'
        minH='750px'
        bg={BRAND_SAND_COLOR}
        py={6}
        display='flex'
        justifyContent='center'
        alignItems='center'
      >
        {selectedPlaylistId ? (
          <PlaylistContentContainer playlistId={selectedPlaylistId} />
        ) : searchValue ? (
          <SearchResult />
        ) : (
          <PlaylistsResult />
        )}
      </Container>

      <Footer />
    </Stack>
  );
}

export default CataloguePage;
